module.exports = __webpack_public_path__ + "img/address.170739bc.svg";